<template>
	<div class="all_bp">  

		<div v-for="BP_ROW in BP.BP_DATA" :key="BP_ROW.id" class="current_bp mt-3" style="height: 900px;" >
			<h1>{{BP_ROW.name}} 
				<span v-if="BP_ERRORS_COUNT>0" @click="showSwal('bp-error',BP_ERRORS)" class="badge badge-pill badge-warning">Ошибки: {{BP_ERRORS_COUNT}}</span> 
				<span class="badge badge-pill badge-primary"  @click="showLegend()">Условные обознаечния</span>
			</h1> 
			<div class="BPSTAGES-row mb-2">
				<h6 class="text-primary mr-3 mb-0">Этапы услуги:</h6>	
				<!-- <div class="BPSTAGES" v-for="stage in BP_ROW.stages" :key="stage.id"><h6 class="mb-0">{{stage.name}}</h6></div> -->
				<div class="BPSTAGES" v-for="stage in stagesoptions.slice(1)" :key="stage.value"><h6 class="mb-0" :style="{'color':stage.color}">{{stage.label}}</h6></div>
			</div>
			
			<div  class="col-md-12 col-lg-10 px-0">
				<h5 class="mb-0">Операции с этапами. Выберите этап, выберите действие</h5>
				<div class="d-flex align-items-center flex-wrap" >
					<!-- <button class="left_btn btn btn-simple btn-primary" @click="AddStage(BP_ROW.id,0)"><i class="tim-icons icon-minimal-left"></i>Добавить этап в начало</button>  -->
					<el-select 
						class="col-md-4 col-12 px-0 select-primary mr-2"
						v-model="stageId" 
						placeholder="Выбрать этап"
						size="large"
						filterable
						clearable
					>
						<el-option
							class="select-primary"
							:style="{'color':stage.color}"
							v-for="stage in stagesoptions"
							:key="stage.value"
							:label="stage.label"
							:value="stage.value"
							>
						</el-option>
					</el-select>
					
					<base-button class="right_btn btn btn-simple btn-success" @click="AddStage(BP_ROW.id,stageId)"><i class="tim-icons icon-simple-add"></i>Добавить этап после выбранного</base-button>
					<!-- <el-tooltip content="Редактировать этап" placement="top"><button class="ml-2 btn btn-icon btn-simple btn-primary" @click="EditStage(BP_ROW.id,stageId)"><i class="tim-icons icon-pencil"></i></button></el-tooltip> -->
					<base-button class="ml-2" @click="EditStage(BP_ROW.id,stageId)" type="primary" simple><i class="tim-icons icon-pencil"></i>Редактировать этап</base-button>
					<base-button class="ml-2" @click="$GVO.showYesNo(function(){RemoveStage(stageId);},'Удаление этапа','Вы действительно хотите удалить этап?');" type="danger" simple><i class="tim-icons icon-trash-simple"></i>Удалить этап</base-button>
					<!-- <el-tooltip content="Удалить этап" placement="top">
						<button class="mx-2 btn btn-icon btn-simple btn-danger" @click="$GVO.showYesNo(function(){RemoveStage(stageId);},'Удаление этапа','Вы действительно хотите удалить этап?');">
						<i class="tim-icons icon-trash-simple"></i>
						</button>
					</el-tooltip> -->
					<base-button class="ml-2" @click="AddTask(BP_ROW.id,stageId)" type="success" simple><i class="tim-icons icon-simple-add"></i>Добавить задачу в этап</base-button>

				</div>

			</div>
			<div  class="col-md-12 col-lg-8 px-0 mt-3">
				<h5 class="mb-0">Расставьте задачи и сохраните координаты</h5>
				<base-button class="" @click="saveCoords(BP_ROW.id)" type="success" simple>Сохранить новые координаты</base-button>
				<!-- <base-button class="" @click="delCoords()" type="success" simple disabled>Удалить из локал сторадж</base-button> -->
			</div>

			<!-- <h4 class="mt-3" >нужно доделать</h4>
			<ol>
				
				
				<li> +++ (пока осталю как есть) +++ первично отображать задачи с группировкой. на что сгодится pleft? --  

					(если pleft =0 -- это х0 в рамках этапа,
						Если 1 - это смещение на 1 ширину задачи, так pleft = 3 -- смещение на 3 ширины задачи.
						Найти самый большой pleft в задачах и следующий этап рисовать на 4 ширину -- он будет стартовой для нового этапа)
				</li>
				<li> +++ как привязать лейблы к двигающимся стрелкам (пока они отрисовываются только по первым координатам)</li>
				<li> +++ придумать что-то с группировкой этапов -- может свое svg</li>
				<li> +++ вернуть подсветку задач</li>
				<li> +++ перерисовывать графы после удаления/добавления чего-либо</li>
				<li> +++ кнопка сохранения расставленных координат? чтобы расставить и оставить</li>
				<li>придумать для Тани копирование какой-то задачи в буффер -- инфа без этапа и может без таскэндов (ее просталяем заново)?</li>

			</ol> -->

						
			<card class="Legend" v-if="legendIsVisib">
				<div class="col">
					<h6>Условные обозначения</h6>
					<div class="d-flex align-items-center text-info">
						<i class="tim-icons icon-refresh-02 mr-2" ></i>
						<p>Можно перезапускать в ручную</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="tim-ic ic-phone mr-2" ></i>
						<p>Можно перезапускать из Лида</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="tim-ic ic-hierarchy mr-2" ></i>
						<p>Это задача singleton</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="tim-icons icon-calendar-60 mr-2" ></i>
						<p>От чего считать начало задачи: От даты из предыдущей задачи</p>
					</div>
					<p><span>С 0 &mdash; </span>через сколько часов старт</p>
					<p><span>Д 0 &mdash; </span>через сколько часов дедлайн</p>
					<p><span class="text-success">И/ИЛИ &mdash; </span>успешные входы</p>
					<p><span class="text-danger">И/ИЛИ &mdash; </span>иные входы</p>
					<div class="row align-items-center mx-0">
						<button class="btn btn-icon btn-simple btn-primary mr-2" style="height: 30px;">
							<i class="tim-icons icon-minimal-up mb-1"></i>
						</button>
						<p> &mdash; перемещение карточки задачи на 1 позицию</p>
					</div>
					<div class="d-flex align-items-center text-info">
						<i class="deadend deadend-success mr-2" ></i>
						<i class="deadend deadend-danger mr-2" ></i>
						<p>Тупик</p>
					</div>
					<div class="d-flex align-items-center text-danger">
						<i class="tim-ic ic-folder mr-2" ></i>
						<p class="mb-0">Архив</p>
					</div>
					<div class="d-flex align-items-center text-success">
						<i class="tim-icons icon-coins mr-2" ></i>
						<p class="mb-0">Сделка</p>
					</div>

					
				</div>
			</card>


			<screen ref="screen" :options="screenOptions" :markers="markers">
				<group  v-for="stage in BP.BP_DATA[0].stages" :nodes=" filterNodesByID(stage.id)" :key="stage.id" :padding="{left: 20, right: 20, top: 60, bottom: 20}"> 
					<div class="mx-3 mt-3">
						<h6 class="mb-0 stageGroupTitle">{{stage.name}} (id: {{stage.id}})</h6>
					</div>
				</group>

				<edge v-for="edge in graph2.edges" 
				:data="{
					from: nodes_for_edges(edge.fromNode), 
					to: nodes_for_edges(edge.toNode), 
					fromAnchor: edge.endType == 'GOOD'?'top-right':'bottom-right',
					toAnchor: edge.endType == 'GOOD'?'top-left':'bottom-left',
					type: 'vsmooth',
					snap: 'rect',
					id: edge.id,
					
				}" 
				:nodes="graph2.nodes" 
				:key="edge.id" 
				:id="edge.id"
				:style="{ stroke: edge.strokeColor, 
					markerStart: edge.endType == 'GOOD'?'url(#circle-start-good)':'url(#circle-start-other)',
					markerEnd: edge.endType == 'GOOD'?'url(#arrow-end-good)':'url(#arrow-end-other)',
				}"></edge>


				<node v-for="node in graph2.nodes" :data="node" height="340" ref="node" :key="node.id" :fit="true" :background="false" textSelect :dragThreshold=10 :margin=10 class="AAA"  >
					<card  
					header-classes="mb-5 mt-1" 
					footer-classes="text-center mb-1 mt-5" 
					style="border: 1px solid #01b0e0; border-radius:6px; max-width: 350px; width: 100%;" 
					
					class="mb-0 "
					>
					<div @mouseenter="getHoveredCardId('task_'+node.id);" class="task-highlight-hover " :id="'task_'+node.id">
						<div class="d-flex"><span class="badge badge-success mr-1" v-if="node.field.IS_START > 0">СТАРТ</span><p>id: {{node.id}}</p></div>
						<!-- <span class="badge badge-info mr-1" >pleft {{node.field.pleft}}</span> -->
						 <!--
						<template v-for="tag in node.field.tags_list">
							<template v-for="tg in masTags">
								<span v-if="tag == tg.id" :key="tg.id" class="badge badge-success mr-2">{{tg.value}}</span>	
								
							</template>	
						</template>						 
					-->
						<span 
							v-for="tg in filteredTags(node)" 
							:key="tg.id" 
							class="badge badge-success mr-2"
						>
							{{tg.value}}
						</span>
						<!-- <p class="text-info">x:{{ node.field.x }} - y: {{ node.field.y }} </p> -->
						<p class="55">{{ node.field.pleft }} {{ node.field.name }} </p>

						<div class="row my-2">
							<p class="col"><span>С {{node.field.START_DT_OFFSET}}, </span><span>Д {{node.field.DEADLINE_OFFSET}}</span></p>
							<div class="col">
								<div class="d-flex justify-content-end">
									<span class="text-success ml-1"  v-if="node.field.successful_outcome_type === 'OR'">ИЛИ </span>
									<span class="text-success ml-1"  v-if="node.field.successful_outcome_type === 'AND'">И </span>
									<span class="text-danger ml-1" v-if="node.field.other_outcome_type === 'OR'">ИЛИ</span>
									<span class="text-danger ml-1" v-if="node.field.other_outcome_type === 'AND'">И</span>
								</div>
							</div>
						</div>

						<div class="agent-otv">
							<p><b v-if="node.field.curator === 'agent'">Агент ответственный за услугу</b></p>
							<p><b v-if="node.field.curator === 'agent_head'">Начальник агента ответсвенного за услугу</b></p>
							<p><b v-if="node.field.curator === 'other_agent'">Сотрудник из текстового поля</b></p>
							<p><b v-if="(node.field.curator != 'agent') && (node.field.curator != 'agent_head') && (node.field.curator != 'other_agent') 
							&& (node.field.curator != 'complex_curator') && (node.field.curator != 'Helpdesk') && (node.field.curator != '')">Сотрудник из текстового поля ID {{node.field.curator}}</b></p>
							<p><b v-if="node.field.curator === 'complex_curator'">Куратор комплекса из предыдущей задачи</b></p>
							<p><b v-if="node.field.curator === 'Helpdesk'">Группа сотрудников из селекта</b></p>
						</div>

						<div class="row align-items-end mx-0">
							<div class="col-8 px-0">
								<div class="row mt-1 mx-0">
									<div class="bp-icon text-info" v-if="node.field.manual_retrying == 1">
										<i class="tim-icons icon-refresh-02" ></i>
									</div>
									<div class="bp-icon text-info" v-if="node.field.lead_retrying == 1">
										<i class="tim-ic ic-phone"></i>
									</div>
									<div class="bp-icon text-info" v-if="node.field.singleton == 1">
										<i class="tim-ic ic-hierarchy"></i>
									</div>
									<div class="bp-icon text-info" v-if="node.field.START_DT_TYPE === 'frm_input_date'">
										<i class="tim-icons icon-calendar-60"></i>
									</div>
									<template v-for="TASKS_END in BP.TASKS_ENDS">
										<div 
											class="bp-icon " 
											v-if="(node.field.id == TASKS_END.BP_TASK_ID) && TASKS_END.tto.includes('\-3')" 
											:key="TASKS_END.id"
										>
											<i class="deadend" :class="[{'deadend-success': TASKS_END.ttype == 'GOOD'}, {'deadend-danger': TASKS_END.ttype == 'OTHER'}]"></i>
										</div>
									</template>
									<template v-for="TASKS_END in BP.TASKS_ENDS">
										<div 
											class="bp-icon" 
											v-if="(node.field.id == TASKS_END.BP_TASK_ID) && TASKS_END.tto.includes('\-2')"
											:key="TASKS_END.id"
										>
											<i class="tim-ic ic-folder text-danger mr-2" ></i>
										</div>
									</template>
									<template v-for="TASKS_END in BP.TASKS_ENDS">
										<div
											class="bp-icon" 
											v-if="(node.field.id == TASKS_END.BP_TASK_ID) && TASKS_END.tto.includes('\-1')"
											:key="TASKS_END.id"
										>
											<i class="tim-icons icon-coins mr-2 text-success" ></i>
										</div>
									</template>
								</div>
								<div class="row mt-1">
									<button class="ml-3 mb-0 btn btn-icon btn-simple btn-primary" @click="EditTask(BP_ROW.id,node.field.BP_STAGE_ID,node.field.id)">
										<i class="tim-icons icon-pencil"></i>
									</button>
																													
									<button class="ml-1 mb-0 btn btn-icon btn-simple btn-danger" @click="$GVO.showYesNo(function(){RemoveTask(node.field.id);},'Удаление задачи','Вы действительно хотите удалить задачу?');">
										<i class="tim-icons icon-trash-simple"></i>
									</button>
									<!-- <button class="ml-1 mb-0 btn btn-icon btn-simple btn-primary" @click="copyTask(BP_ROW.id,node.field.BP_STAGE_ID,node.field.id)">
										<i class="tim-icons icon-trash-simple"></i>
									</button> -->

								</div>
							</div>
							
						</div>
						<template v-for="item in stagesoptions">
							<div 
								class="row align-items-baseline justify-content-between mx-0 mt-2" 
								:style="{'background-color':item.color}" 
								
								v-if="item.value == node.field.BP_STAGE_ID "
								:key="item.id"
							>
								<p class="my-1 mx-auto"  >этап id {{ node.field.BP_STAGE_ID }}</p>
							</div>
						</template>
					</div>
					</card>
				</node> 

				<Label v-for="edge in graph2.edges" 
				ref="label"
				:edge="{
					from: nodes_for_edges(edge.fromNode), 
					to: nodes_for_edges(edge.toNode), 
					fromAnchor: edge.endType == 'GOOD'?'top-right':'bottom-right',
					toAnchor: edge.endType == 'GOOD'?'top-left':'bottom-left',
					type: 'vsmooth',
					snap: 'rect',
					id: edge.id,
					
				}" 
				:perc="50" 
				:offset="{x: 0, y: 0}" 
				:width="370" 
				:connector="true" 
				:useDrag="true" 
				:rotate="false" 
				align="center" 
				:key="edge.id"
				>
					<div style="padding: 10px; color:white;">{{edge.taskendName}}</div>
				</Label>
					
			</screen>	

		</div>

	</div>	
</template>
<script>
// import LeaderLine from 'leader-line-vue';
import swal from 'sweetalert2';
import { Select, Option, Tooltip, Button, /*FormItem,*/ } from 'element-ui';
// import { elementMatches } from '@fullcalendar/core';
// import { addClass, removeClass } from 'element-ui/src/utils/dom';
//import { Screen, Node, Edge, Group, Label, Port, Markers, graph, VLabel } from 'vnodes'
import { Screen, Node, Edge, Group, Label, /*Port,*/ graph } from 'vnodes'



export default {
	name: 'BPC-page', //copy of BP-page
	components: {
		// LeaderLine,
		//VLabel,
		Screen, 
		Node, 
		Edge, 
		Group, 
		Label, 
		// Port, 
		//Markers, 
		// graph,
        [Option.name]: Option,
        [Select.name]: Select,
        [Tooltip.name]: Tooltip,
        [Button.name]: Button,
	},
	props: {
		
		
	},
	data() {
	    return {
			BP: {},
			Plumbs:[],
			BP_ERRORS: {},
			BP_ERRORS_COUNT: 0,
			bp_id: null,
			legendIsVisib: false,
			hoveredTaskId: '',
			masTags:[],
			tagsList: [],
			// deadendicon: false,
			graph0: new graph(),
			graph: new graph(),
			graph2: new graph(),
			screenOptions: {dblClickZoomEnabled: true},
			markers: [
				{ id:'arrow-start-blue', type:'arrow-start', scale:0.5, style:'fill: blue'},
				{ id:'arrow-end-blue', type:'arrow-end', scale:0.5, style:'fill: blue' },
				{ id:'squared', type:'square', scale: 1, style:'fill: blue;'},
				{ id:'circular', type:'circle', scale: 1, style:'fill: blue'},
				{ id:'crossed', type:'cross', scale: 1, style:'stroke: blue'},
				{ id:'arrow-slim-start-blue', type:'arrow-slim-start', scale: .5, style:'stroke: blue'},
				{ id:'arrow-slim-end-blue', type:'arrow-slim-end', scale: .5, style:'stroke: blue'},
				//Ниже наши, выше дефолтные
				{ id:'circle-start-good', type:'circle', scale: 1, style:'fill: #00BF9A'},
				{ id:'circle-start-other', type:'circle', scale: 1, style:'fill: #F84E54'},
				{ id:'arrow-end-good', type:'arrow-end', scale: .6, style:'fill: #00BF9A'},
				{ id:'arrow-end-other', type:'arrow-end', scale: .6, style:'fill: #F84E54'},
			],
			stagecolors: ["#01B0E099", "#00BF9A99", "#F84E5499", "#FF8D7299", "#9E77F399"],
			// stagecolors: ["#01B0E0", "#00BF9A", "#F84E54", "#FF8D72", "#9E77F3"],
			stageId: '',
			stagesoptions: [],
			savedCoordsData: [], //кажется нужны оба
			savedCoordsData2: [], //кажется нужны оба
			copiedTask: {}
	    };
    },
	watch: {

	},
	computed: {
		nodes_for_edges(){
			// let vm=this;
			return function(data){
				let result={};
				//console.log(data); // это edge.fromNode
				for(let i = 0; i < this.graph2.nodes.length; i++){
					if(this.graph2.nodes[i].id == data.id){
						result = this.graph2.nodes[i];
						
					}
				}
				// console.log(result); 
				return result;
			}
		},
		filterNodesByID(){
			// let vm=this;
			return function(data){
				let result=[];
				// console.log(data); // это edge
				for(let i = 0; i < this.graph2.nodes.length; i++){
					if(this.graph2.nodes[i].field.BP_STAGE_ID == data){
						result.push(this.graph2.nodes[i]);
						// console.log(result); 
					}
				}
				return result;
			}
		}
	},
	methods: {
		filteredTags(node) {
			return this.masTags.filter(tg => 
				node.field.tags_list.includes(String(tg.id))
			);
		},

		getBP(){
			// console.log(this.$route.params.bp_id);
			this.$GVO.ApiCall('GET',{obj:'BP',flt:{'id':this.$route.params.bp_id, 'showall':true} })
			.then((objApi) => {
			    if(objApi.success === true){
					this.bp_id = this.$route.params.bp_id;
				    this.BP = objApi.data;
					this.paintPlumb();
					this.computeNodeData(this.BP.BP_DATA[0].stages, this.BP.TASKS_ENDS);

					this.$GVO.ApiCall('CHECK_BP',{obj:'BP',flt:{'id':this.bp_id} })
						.then((objApi) => {
							if(objApi.success === true && objApi.errors_count>0){
								this.BP_ERRORS_COUNT = objApi.errors_count;
								this.BP_ERRORS = objApi.errors;
								//console.log(objApi);
							}
						}).catch(errorObjApi => console.error(errorObjApi));
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		computeNodeData(data, taskends, x, y){ //перенести в computed? и повесить вотчер? // упд2: данные в computed вычисляются раньше, чем получаются данные 'GET',{obj:'BP'
			let xstart=-350;
			let ystart=-160;
			// let currentpleft=0;
			// let previouspleft=0;
			// let currentBPStage=0;
			// let previousBPStage=0;
			let flatArrTasks = [];
			
			//первично отображать задачи с группировкой. на что сгодится pleft? -- (если pleft =0 -- это х0 в рамках этапа, 
			//Если 1 - это смещение на 1 ширину задачи, так pleft = 3 -- смещение на 3 ширины задачи. 
			//Найти самый большой pleft в задачах и следующий этап рисовать на 4 ширину -- он будет стартовой для нового этапа)
			
			
			this.stagesoptions = []; //массив для селекта формы add/edit stages
			this.stagesoptions.push({label: 'В начало', value: 0});		
			this.graph0.reset();
			this.graph2.reset();

			

			for(let i = 0; i < data.length; i++){
				const hue = Math.random() * 360;
				// const lightness = Math.random() * 75;
				const saturation = Math.random() * 85;
				const randomColor = `hsl(${hue}, ${saturation}%, ${55}%, 0.6 )`;

				this.stagesoptions.push({label: data[i].name, value: data[i].id, color: randomColor});


				flatArrTasks.push(...data[i].TASKS); //собираю в один массив, чтобы можно было удобно воспользоваться обращением к предыдущему елементу массива
				
			// пока не удалять for ниже
				// for(let j = 0; j < data[i].TASKS.length; j++){
					
				// 	currentpleft = data[i].TASKS[j].pleft;
				// 	// currentBPStage = data[i].TASKS[j].BP_STAGE_ID;
					
				// 	if(currentpleft == 0){
				// 		previouspleft == 0; 
						
				// 	}else {
				// 		previouspleft = data[i].TASKS[j].pleft -1;
				// 	}
				// 	// console.log('currentpleft id ',data[i].TASKS[j].id, 'currentpleft ', currentpleft);
				// 	// console.log('previouspleft id ',data[i].TASKS[j].id, 'previouspleft ', previouspleft);
					
				// 	if(data[i].TASKS[j].IS_START > 0){ //Object.hasOwnProperty('error')
				// 		// console.log('start id ', data[i].TASKS[j]);
				// 		xstart = 350;
				// 		ystart += 340;
				// 	} else if( (data[i].TASKS[j].pleft >=0) && (data[i].TASKS[j].pleft == previous.pleft)){ 
						
				// 		//&& (data[i].TASKS[j].pleft == previouspleft)

				// 		// if(data[i].TASKS[j].pleft == previouspleft){
				// 		// 	console.log('TASKS id ',data[i].TASKS[j].id, 'pleft ', data[i].TASKS[j].pleft);
				// 		// 	// console.log('TASKS id ',data[i].TASKS[j].id, 'pleft ', data[i].TASKS[j].pleft);
							
				// 		// }
				// 		// console.log('currentpleft id ',data[i].TASKS[j].id, 'currentpleft ', currentpleft);
				// 		// console.log('previouspleft id ',data[i].TASKS[j].id, 'previouspleft ', previouspleft);

				// 		if(data[i].TASKS[j].pleft ==0){
				// 			xstart += 350*(previous.pleft+1);
				// 		}else {xstart += 350*data[i].TASKS[j].pleft;}
						
				// 		ystart += 110; // было 110
				// 		//&& (data[i].TASKS[j].pleft == data[i].TASKS[j-1].pleft)
						
				// 		// console.log('start id ', data[i].TASKS[j].id, ' pleft ', data[i].TASKS[j].pleft);

						

				// 	} 
				// 	else {
				// 		xstart += 400; // было 350
				// 		ystart += 110; // было 110
				// 	}
					
				// 	if(x == undefined)data[i].TASKS[j].x = xstart;
				// 	if(y == undefined)data[i].TASKS[j].y = ystart;

													
				// 	this.graph2.createNode({
				// 		id:data[i].TASKS[j].id, 
				// 		field:data[i].TASKS[j], 
				// 		x:data[i].TASKS[j].x, 
				// 		y:data[i].TASKS[j].y,
						
				// 	}); // влитые координаты, а нужны обновляемые
					
				// }



				// this.graph0.createNode({
				// 	id:data[i].id, 
				// 	// field:data[i].TASKS[j], 
				// 	x:data[i].TASKS[0].x, 
				// 	y:data[i].TASKS[0].y,
				// }); //стадии, пока это бесполезно
			}

			if(this.savedCoordsData.length > 0) {
					this.graph2.nodes = this.savedCoordsData;
			} else {
				
				flatArrTasks.sort((a, b) => a.BP_STAGE_ID - b.BP_STAGE_ID || a.pleft - b.pleft || a.id - b.id);
				// console.log(flatArrTasks);
				var len = flatArrTasks.length;
				

				for(let j = 0; j < flatArrTasks.length; j++){
					
					var previous = flatArrTasks[(j+len-1)%len];
					// var current =  flatArrTasks[j];
					// var next = flatArrTasks[(j+1)%len];
											
					if(flatArrTasks[j].IS_START > 0){ 
						// console.log('start id ', data[i].TASKS[j]);
						xstart = 350;
						ystart += 400;
					} else if(flatArrTasks[j].pleft >=0 && flatArrTasks[j].IS_START < 1){ 

						if(flatArrTasks[j].BP_STAGE_ID != previous.BP_STAGE_ID && previous.BP_STAGE_ID!=undefined && ( flatArrTasks[j].pleft != previous.pleft)){
							// console.log('TASKS id ',flatArrTasks[j].id, 'previous ',previous.pleft);
							if(flatArrTasks[j].pleft == 0){
								xstart =  previous.x+400;
							}else {
								xstart =  400*flatArrTasks[j].pleft;
							}
							ystart = 240;
						}
						else if (flatArrTasks[j].BP_STAGE_ID != previous.BP_STAGE_ID && ( flatArrTasks[j].pleft == previous.pleft)){
							xstart =  previous.x;
							ystart = 240;
						}
						else if(flatArrTasks[j].BP_STAGE_ID == previous.BP_STAGE_ID && ( flatArrTasks[j].pleft == previous.pleft)){
							xstart =  previous.x;
							// ystart = previous.y + 240;
							ystart = previous.y + 300;
							// ystart = 240;
						
						} 
						
						else {
							xstart +=  400;
							ystart += 360;
							// xstart =  350*flatArrTasks[j].pleft;
						}

					} 
					
					if(x == undefined)flatArrTasks[j].x = xstart;
					if(y == undefined)flatArrTasks[j].y = ystart;

													
					this.graph2.createNode({
						id:flatArrTasks[j].id, 
						field:flatArrTasks[j], 
						x:flatArrTasks[j].x, 
						y:flatArrTasks[j].y,
						
					}); // влитые координаты, а нужны обновляемые

				}

			}
			
			// console.log('this.graph2', this.graph2);

			for(let TEi in taskends){ 
				let TE = taskends[TEi]; //console.log(TE);
				
				this.$nextTick(()=>{
					let line = {task_from:'',task_tto:''}; //console.log(TE.tto);
					let tto_imp = TE.tto.split(','); //console.log(tto_imp);
					let field = {};
					let strokeColor = '#00BF9A';
					for(let onet_tto in  tto_imp){ //console.log(tto_imp[onet_tto]);
						if(tto_imp[onet_tto]==''||tto_imp[onet_tto]==undefined || tto_imp[onet_tto].includes('\-')){ continue; }
						if(onet_tto!=''){
							//console.log(TE.ttype);
							if(TE.ttype=='GOOD'){
								strokeColor = '#00BF9A';
							}else {strokeColor = '#F84E54';}
							line.task_from = TE.BP_TASK_ID; //.toString()
							line.task_tto = tto_imp[onet_tto];
							
							field = this.getNodeCoords(this.graph2.nodes, line.task_from, line.task_tto, strokeColor, TE.ttype, TE.name);
							this.graph2.createEdge(line.task_from, line.task_tto, field);
						}
					}
				});
			}

			this.graphNodes();
			// this.$refs.label.$refs.node.fitContent();
		},
		getNodeCoords(arr, fromNode_id, toNode_id, strokeColor, endType, taskendName){

			let nodefield = {fromNode:{x:'', y:''}, toNode:{x:'', y:''}};
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].id == fromNode_id && arr[i].id == toNode_id){ //для ибучих задча, у которых исходы идут сами в себя
					nodefield.fromNode.x = arr[i].x;
					nodefield.fromNode.y = arr[i].y;
					nodefield.fromNode.id = fromNode_id;
					nodefield.toNode.x = arr[i].x;
					nodefield.toNode.y = arr[i].y;
					nodefield.toNode.id = toNode_id;
					nodefield.strokeColor = strokeColor;
					nodefield.endType = endType;
					nodefield.taskendName = taskendName;
				}
				else if(arr[i].id == toNode_id){
					nodefield.toNode.x = arr[i].x;
					nodefield.toNode.y = arr[i].y;
					nodefield.toNode.id = toNode_id;
					nodefield.strokeColor = strokeColor;
					nodefield.endType = endType;
					nodefield.taskendName = taskendName;
				} else if(arr[i].id == fromNode_id){
					nodefield.fromNode.x = arr[i].x;
					nodefield.fromNode.y = arr[i].y;
					nodefield.fromNode.id = fromNode_id;
					nodefield.strokeColor = strokeColor;
					nodefield.endType = endType;
					nodefield.taskendName = taskendName;
				} 
			}
			return nodefield;
		},
		graphNodes () {
			this.graph2.graphNodes({
			nodes: this.graph2.nodes,
			edges: this.graph2.edges,
			type: 'basic',
			dir: 'right',
			spacing: 150
			});
			
		},
		saveCoords(bp_id){
			
			this.savedCoordsData2 = [];
			let localStorageBPName = 'BP-task-coords2';
			let localStorageBObj = {};

			if(localStorage.hasOwnProperty(localStorageBPName)) {
				let tmpSavedCoordsData = [];

				tmpSavedCoordsData = JSON.parse(localStorage.getItem('BP-task-coords2'));
				localStorageBObj = {id: this.checkBPid(bp_id), nodes: this.graph2.nodes};

				this.savedCoordsData2.push(...tmpSavedCoordsData, localStorageBObj);
				this.delCoords();
				localStorage.setItem(localStorageBPName, JSON.stringify(this.savedCoordsData2));

				// console.log("this.savedCoordsData2", this.savedCoordsData2);
			} else {
				localStorageBObj = {id: this.checkBPid(bp_id), nodes: this.graph2.nodes};
				this.savedCoordsData2.push(localStorageBObj);
				localStorage.setItem(localStorageBPName, JSON.stringify(this.savedCoordsData2));
				// console.log(localStorageBPName);
			}

		},
		getSavedCoords(bp_id){

			if(localStorage.hasOwnProperty("BP-task-coords2")) {
				this.savedCoordsData2 = JSON.parse(localStorage.getItem('BP-task-coords2'));

				for(let i = 0; i < this.savedCoordsData2.length; i++){
					if (this.savedCoordsData2[i].id == this.$route.params.bp_id){
						this.savedCoordsData = this.savedCoordsData2[i].nodes;
						break;
					}
				}
				// console.log("this.savedCoordsData", this.savedCoordsData);
			}

		},
		delCoords(){
			localStorage.removeItem('BP-task-coords2');
		},
		checkBPid(bp_id){
			return bp_id||this.bp_id;
		},
		AddTask(bp_id,stage_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(this.bp_id,stage_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/add/task?stage_id='+stage_id});
			// this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/add/task?stage_id='+stage_id});
		},
		EditTask(bp_id,stage_id,task_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			// console.log(bp_id,stage_id,task_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/edit/task/'+task_id});
		},
		RemoveTask(task_id){
			//console.log(task_id);
			this.$GVO.ApiCall('DEL_TASK',{obj:'BP',flt:{'id':task_id} })
			.then((objApi) => {
			    if(objApi.success === true){
				    this.$router.go();
			    }
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		AddStage(bp_id,stage_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(bp_id,stage_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/add/stage?add_after='+stage_id});
			// this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/add/stage?add_after='+stage_id});
		},
		EditStage(bp_id,stage_id){
			//if(typeof bp_id == 'undefined' || bp_id == null || bp_id == '') bp_id = this.bp_id;
			//console.log(bp_id,stage_id);
			this.$router.push({path: '/data/settings/bp_editor/id/'+this.checkBPid(bp_id)+'/edit/stage/'+stage_id});
		},
		RemoveStage(stage_id){
			//console.log(stage_id);
			this.$GVO.ApiCall('DEL_STAGE',{obj:'BP',flt:{'id':stage_id} })
			.then((objApi) => {
			    if(objApi.success === true){
				    this.$router.go();
			    }
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		refresh(){
		    this.getBP();
		},

		getHoveredCardId(e){
			this.hoveredTaskId = e;
			// this.hoveredTaskId = e.target.id;
			let hoveredCard = document.getElementById(this.hoveredTaskId);
			// console.log(hoveredCard);
			for (let i = 0; i < this.Plumbs.length; i++) {
				if(this.Plumbs[i].source == this.hoveredTaskId){
					// console.log(this.Plumbs[i].source);
					let temIds = this.Plumbs[i].target.split(',');
					for(let i = 0; i < temIds.length; i++) {
						if(temIds[i] != '' && temIds[i] != 'task_' && temIds[i] > 0) { 
							let connectedCards = document.getElementById('task_'+temIds[i]); 
							connectedCards.classList.add('task-highlight');

							hoveredCard.addEventListener('mouseleave', e => {
								connectedCards.classList.remove('task-highlight');
							});
						}
					}

				}				
			}
			
        },		
		paintPlumb(){
		    this.Plumbs=[];
		    for(let TEi in this.BP.TASKS_ENDS){ 
				let TE = this.BP.TASKS_ENDS[TEi]; //console.log(TE);
				this.Plumbs.push({source:'task_'+TE.BP_TASK_ID,target:'task_'+TE.tto});
		    }
		},
		showSwal(type,data=[]){
			if (type === 'bp-error') {
				let masErFields = [];
				let masErTasks = [];
				let iNo = 0;
				for (let key in data) {
					for (let i = 0; i < data[key].data.length; i++) {
						if(data[key].data[i].name !== null && data[key].data[i].id !== null){
							masErTasks.push(`ID: ${data[key].data[i].id} ; ИМЯ: ${data[key].data[i].name}`);
						}
					}
					if(masErTasks.length == 0){masErTasks.push('Задачи не определяются, возможно они NULL.')}
					iNo++;
					masErFields.push(`${iNo}) ${data[key].msg}: ${masErTasks.join(', ')}`);
				}
				swal({
					title: 'Ошибки в бизнес процессе',
					buttonsStyling: false,
					confirmButtonClass: 'btn btn-danger btn-fill',
					html: `<div class="error-content">${masErFields.join('<br>')}</div>`
				});
			}
		},
		showLegend(){
			this.legendIsVisib = !this.legendIsVisib;
		},
		// copyTask(data){
		// 	console.log('copyTask data', data);
		// 	// localStorage.setItem('copiedTask_BP', JSON.stringify(this.copiedTask));

		// },
		

	},
	mounted() {	
		// if(localStorage.hasOwnProperty("BP-task-coords")) {
		// 	this.savedCoordsData2 = JSON.parse(localStorage.getItem('BP-task-coords'));
		// 	// console.log("StorageData", StorageData);
		// }	
		this.getSavedCoords();
	    this.$nextTick(()=>{
			this.getBP();	
	    }); 

		if(typeof this.$GVO.cats.CAT_BP_TASK_TAGS == 'undefined'){
			this.$GVO.LoadCatPromise('CAT_BP_TASK_TAGS')
			.then((objApi) => {
				for (let i = 0; i < this.$GVO.cats.CAT_BP_TASK_TAGS.length; i++) {
					const element = this.$GVO.cats.CAT_BP_TASK_TAGS[i];
					if(element.act==1) this.masTags.push({'value':element.val,'label':element.name, 'id':element.id}); //вопрос val или id ?
				}
			})
			.catch(errorObjApi => {console.error(errorObjApi); });
		}else{
			for (let i = 0; i < this.$GVO.cats.CAT_BP_TASK_TAGS.length; i++) {
				const element = this.$GVO.cats.CAT_BP_TASK_TAGS[i];
				if(element.act==1) this.masTags.push({'value':element.val,'label':element.name, 'id':element.id}); //вопрос val или id ?
			}
		}
		
		this.$nextTick(() => {
			this.graphNodes();
		});
		
	},	 
	created () {
		
		// this.getBP();
	}
};
</script>
<style scoped>
	.all_bp .card{
		display: inline-flex;
		width: auto;
		margin-right: 15px;
		min-width: 330px;
	}	
	.current_bp{ /* overflow-x: auto; */}
	/* .current_bp > .d-flex {width: max-content; padding-top: 40px;} */
	/* .current_bp h1 {
		margin-bottom: 40px;
	} */
	.btn-simple{padding: 10px 18px;}
	.tim-icons {padding: 0 3px 0 3px;} 
	
	.btnsAddStage{
		width: 100%;
		display: flex;
		justify-content: space-between;
		position: absolute;
		top:-60px;
		left:0px;
	}
	.all_bp .card:not(:first-of-type) .btnsAddStage .left_btn{visibility:hidden;}
	.ps__rail-y {
	 /*    display:none; */
	}
	.ps__rail-x {
	/*    display:none; */
	}	

	.btn:not(.btn-icon) .tim-icons, .navbar .navbar-nav > a.btn:not(.btn-icon) .tim-icons {top: -1px;}

	h1 .badge{vertical-align: super; cursor: pointer;}

	.in_round {
            position: absolute;
	    top: -10px;
	    left: -10px;
	    border-radius: 8px;
	    background-color: #00BF9A;
	    width: 15px;
	    height: 15px;
	}
	
	.out_round {
            position: absolute;
	    top: -10px;
	    right: -10px;
	    border-radius: 8px;
	    background-color: #00BF9A;
	    width: 15px;
	    height: 15px;
	}	
	
	.in_round_other {
            position: absolute;
	    bottom: -10px;
	    left: -10px;
	    border-radius: 8px;
	    background-color: #F84E54;
	    width: 15px;
	    height: 15px;
	}
	
	.out_round_other {
            position: absolute;
	    bottom: -10px;
	    right: -10px;
	    border-radius: 8px;
	    background-color: #F84E54;
	    width: 15px;
	    height: 15px;
	}
	.bp-icon {
		width: 38px;
		padding: 4px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.bp-icon i {font-size: 18px;}
	.Legend {
		z-index: 10;
		position: absolute;
		border: 1px solid #01b0e0;
	}
	.Legend i { font-size: 18px;}

	.task-highlight, .task-highlight-hover:hover {
		box-shadow: 0 1px 100px 0 rgba(234, 143, 249, 1)!important;
	}

	.deadend {
		width: 20px;
		height: 20px;
		display: block;
	}
		
	.deadend-danger{
        background-image: url('/img/icons/deadend.svg');
		background-repeat: no-repeat;
    }
	.deadend-success{
        background-image: url('/img/icons/deadendsuccess.svg');
		background-repeat: no-repeat;
    }

	.all_bp >>> .node .content {white-space: normal!important; background-color: rgba(1, 176, 224, .9); }
	.all_bp >>> .label .edge {
	stroke: rgba(1, 176, 224, 1);
	/* stroke-width: 3;
	stroke-dasharray: 4; */
	}
	/* .all_bp >>> svg .edge {marker-end: url(#arrow-end-red)!important;} */
	.all_bp >>> .BPSTAGES-row {display: flex; flex-wrap: wrap; align-items: baseline;}
	.all_bp >>> .BPSTAGES {position: relative; margin-right: 20px;}
	.all_bp >>> .BPSTAGES:not(:last-child) h6::after{
		content: '>';
		position: absolute;
		right: -15px;
		top: 0 ;
	}
	.stageGroupTitle {font-size: 20px;}
	foreignObject {
		overflow: visible;
	}
	
</style>
